/** Display name: first + last, then accountName, then email local-part. */
export function getCustomerDisplayName(customer: {
  firstName?: string | null;
  lastName?: string | null;
  accountName?: string | null;
  email?: string | null;
}): string {
  const fromNames = `${customer.firstName ?? ""} ${customer.lastName ?? ""}`.trim();
  if (fromNames) return fromNames;

  const account = customer.accountName?.trim();
  if (account) return account;

  const email = customer.email?.trim();
  if (email) return email.split("@")[0] || email;

  return "N/A";
}
